export * from './useGetSearchConfigFromLocalStorage';
